// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar'; // Import Navbar component
import Footer from './components/Footer'; // Import Footer component
import Home from './pages/Home'; // Import the Home component
import AboutUs from './pages/AboutUs'; // Import AboutUs component
import Features from './pages/Features'; // Import Features component
import HowItWorks from './pages/HowItWorks'; // Import HowItWorks component
import Home2 from './pages/Home2'; // Import the new Home2 component
import Home3 from './pages/Home3'; // Import the new Home3 component
import Home4 from './pages/Home4'; // Import the new Home4 component
import Login from './pages/Login';
import ContactUs from './pages/ContactUs'; // Adjust the path based on your file structure



const App = () => {
  return (
    <Router>
      {/* Navbar component */}
      <Navbar />

      {/* Define the routes */}
      <Routes>
        <Route path="/" element={
          <div>
            {/* The main Home component containing all sections */}
            <Home />
            <Home2 />
            <Home3 />
            <Home4 />
          </div>
        } /> {/* Home page route */}
        
        <Route path="/about-us" element={<AboutUs />} /> {/* About Us route */}
        <Route path="/features" element={<Features />} /> {/* Features route */}
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/how-it-works" element={<HowItWorks />} /> {/* How It Works route */}
        <Route path="/login" element={<Login />} />
      </Routes>

      {/* Footer component */}
      <Footer />
    </Router>
  );
};

export default App;
